import type React from 'react';

import type { CompassData } from '@xing-com/crate-jobs-helpers';

import { CultureLegend } from '../culture-legend';

import { CultureCompass } from './culture-compass';
import { CompassWrapper } from './culture-compass-wrapper.styles';

type Props = {
  compass: CompassData;
  companyName: string;
};

export const CultureCompassWrapper: React.FC<Props> = ({
  compass,
  companyName,
}) => {
  return (
    <CompassWrapper aria-hidden>
      <CultureLegend companyName={companyName} />
      <CultureCompass
        industryAngle={compass?.industry}
        profileAngle={compass?.profile}
      />
    </CompassWrapper>
  );
};
